import { ErrorHandler, Injectable } from '@angular/core';
import { reloadOnceForChunkError } from './chunk-load';

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (reloadOnceForChunkError(error)) {
      return;
    }

    console.error(error);
  }
}
